module.exports = __webpack_public_path__ + "static/img/2.6630c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件八/2.jpg
// module id = aCV8
// module chunks = 1